/* eslint-disable */
import qs from 'qs'
import axios from 'axios'
import jsonp from 'jsonp'
import CryptoJS from 'crypto-js'
import { isObject } from 'lodash'
import { Sniff, syncTime } from './q_sniff'
import { getStorge } from './q_business'
import { getAESKeys, encryptAES } from './secret'
import tjCookie from '@/utils/tjCookie'
const LOCATION = 'my_location'
let firstPageId = null
const { uid = '', vid = '', model = '' } = Sniff.bnb_tujia || {}

const userID = (Sniff.uinfo && Sniff.uinfo.uid) || ''
const deviceInfo = {
  appVersion: vid, // vid
  model: model, // 设备型号 iphone6,1
  deviceID: uid, // uid
  source: Sniff.qunar ? 'app' : 'touch', // app/www/touch
  platform: Sniff.ios ? 'ios' : 'adr',
  osVersion: Sniff.osVersion, // 操作系统版本
  userID,
  networkType: Sniff.networkType // 运营商 网络类型
}
// 灰度标签，java接口放到headers里
const xTrafficTag = tjCookie.getXTrafficTag() ? {
  'X-Traffic-Tag': tjCookie.getXTrafficTag()
} : {}

// 计算日志参数
function getLogParamsFromUrl() {
  const href = window.location.href || ''
  // 当前页面
  const curPagePattern = href.match(/#\/([\w]+)\?*/)
  const curPage = curPagePattern ? curPagePattern[1] : ''

  const curIdPattern = href.match(/curPageId=([\w]+)(&|$)/)
  const curPageId = getCurPageId(curPage)

  // 上级来源页面
  const refPagePattern = href.match(/refPage=([\w]+)(&|$)/)
  const refPage = (refPagePattern && refPagePattern[1]) || ''

  const refIdPattern = href.match(/refPageId=([\w]+)(&|$)/)
  const refPageId = refIdPattern ? refIdPattern[1] : ''

  // 日志fromForLog
  const logPattern = href.match(/fromForLog=([A-Za-z\d-]+)(&|$)/)

  const fromForLog = (logPattern && logPattern[1]) || 5400

  return {
    curPage,
    curPageId,
    refPage,
    refPageId,
    fromForLog
  }
}

function _jsonp(params) {
  const { url, extraParam = {} } = params
  return new Promise((resolve, reject) => {
    jsonp(
      url + qs.stringify(extraParam, { addQueryPrefix: true }),
      {
        param: 'callback',
        timeout: 10000
      },
      function(err, data) {
        if (err) {
          return reject(err)
        }
        return resolve(data)
      }
    )
  })
}

function getCurPageId(pageName) {
  const href = window.location.href || ''
  const curIdPattern = href.match(/curPageId=([\w]+)(&|$)/)
  const curPageId = curIdPattern
    ? curIdPattern[1]
    : firstPageId
      ? firstPageId
      : (() => {
          const { uid } = Sniff.bnb_tujia
          firstPageId = CryptoJS.MD5(`${uid}_${pageName}_${new Date().getTime()}`).toString()
          return firstPageId
        })()
  return curPageId
}

function _appendToUrl(url, value) {
  if (url.indexOf('?') !== -1) {
    if (url[url.length - 1] === '&') {
      url += value
    } else if (url[url.length - 1] === '?') {
      url += value
    } else {
      url += '&' + value
    }
  } else {
    url += '?' + value
  }
  return url
}

const typeMap = function(type) {
  return (
    {
      text: 'text/plain;charset=UTF-8',
      json: 'application/json;charset=UTF-8',
      form: 'application/x-www-form-urlencoded;charset=UTF-8'
    }[type] || '*/*'
  ) // 避免被压缩
}

// 记录错误日志信息
const recordErr = (errmsg, options = {}) => {
  const logParam = getLogParamsFromUrl()
  const logContent = JSON.stringify({
    ...logParam,
    ...options,
    errmsg,
    actTime: new Date().toString('YYYY-MM-DD HH:mm:ss:SSS'),
    deviceInfo
  })
  qFetch({
    url: '/tjbnb/app/log/logfront',
    data: {
      logType: 'errLog',
      logContent
    }
  })
    .then((res) => {})
    .catch((err) => {})
}

// 计算c参
const cParams = (queryObj = true) => {
  const { uid, gid, vid, pid, releaseType = '', model = '' } = Sniff.bnb_tujia || {}
  const { os, osVersion, qunar, uinfo = {} } = Sniff || {}

  const { lat, lng } = getStorge(LOCATION) || {}
  const logParams = getLogParamsFromUrl()
  const c = {
    uid,
    gid,
    vid,
    pid,
    osVersion,
    releaseType,
    model,
    platform: Sniff.ios ? 'iOS' : 'Android',
    appVersion: Sniff.appVersion,
    currLatitude: lat || '',
    currLongitude: lng || '',
    lat: lat || '',
    lon: lng || '',
    cityName: '',
    userId: uinfo.uid || '',
    userName: uinfo.username || '',
    bucket: 'B',
    osn: os || 'pc', //平台
    osv: osVersion || 'unknow',
    source: qunar ? 'mobile' : 'touch',
    traceId: CryptoJS.MD5(`${uid || 'touch'}-${new Date().getTime()}`).toString(),
    ...logParams
  }
  return queryObj ? c : JSON.stringify(c)
}

function request(params) {
  let { url = '', method = 'POST', data, timeout = 10000, headersConfig = {}, requestType = 'json', responseType = 'json' } = params,
    random = encodeURIComponent('_r' + Math.floor(Math.random() * 100000)) + '=' + encodeURIComponent(Date.now()),
    hasData = Object.prototype.toString.call(data) === '[object Object]' ? true : false,
    commonHeadersConfig = {}

  if (!url) {
    return
  }

  // 设置请求类型和响应类型
  requestType && (commonHeadersConfig['Content-Type'] = typeMap(requestType))
  responseType && (commonHeadersConfig['Accept'] = typeMap(responseType))

  // 处理传输数据
  let payload = {}
  if (method === 'POST') {
    let key = ''
    const needEncrypt = process.env.NODE_DEPLOY == 'production'
    if (needEncrypt) {
      key = getAESKeys()
      commonHeadersConfig['4f6f44cf6b27bbaf'] = key.sec
    }
    let body = null
    hasData && (body = commonHeadersConfig['Content-Type'].indexOf('application/x-www-form-urlencoded') !== -1 ? stringifyUrlParam(data) : needEncrypt ? encryptAES(key.origin, JSON.stringify(data)) : JSON.stringify(data))
    payload = {
      data: body
    }
  } else if (method === 'GET') {
    payload = {
      params: data,
      paramsSerializer: function(params) {
        return qs.stringify(params, {})
      }
    }
  } else if (method === 'JSONP') {
    return _jsonp(params)
  }

  const ajaxData = {
    url: _appendToUrl(url, random),
    method,
    timeout,
    headers: { ...commonHeadersConfig, ...headersConfig, ...xTrafficTag },
    ...payload
  }
  // 如果是日志请求，失败则不需要报告
  let hasReportErr = true
  if (params.url.indexOf('/log/logfront') > -1) {
    hasReportErr = false
  }

  return axios
    .request(ajaxData)
    .then((res) => {
      return res.data
    })
    .then((res) => {
      syncTime(res.time)
      return res
    })
    .catch((err) => {
      hasReportErr &&
        recordErr(JSON.stringify(err), {
          requestUrl: params.url,
          npm: 'axios',
          version: '2.0'
        })
      throw err
    })
}

function qFetch(params) {
  if (!isObject(params) || !params.url) {
    return
  }

  let body = {}
  body.b = params.data || {}

  // 是否需要默认c参
  if (!params.exceptC) {
    body.c = cParams()
  }

  // 自定义请求接口参数
  if (params.extraParam) {
    body = {
      ...body,
      ...params.extraParam
    }
  }

  // 自定义请求接口扩展C参
  if (params.extraCParams && body.c) {
    body.c = {
      ...body.c,
      ...params.extraCParams
    }
  }
  params.data = body
  return request(params)
}

export default qFetch

export { getLogParamsFromUrl }
